module.exports = __webpack_public_path__ + "static/off-map-287ee9b7a8b0901efc9f6e57c297bd4e.svg";